import React, { useState } from 'react'

const TabWithBottomBorder = ({ getTabContent, tabs, activeTab, setActiveTab, setValue }) => {

  return (
    <div className="mytabs-container">
      <div className="mytabs mytab-v2">
        {
          tabs.map((tab, index) => {
            return (
              <button
                className={activeTab === index ? 'mytab mytab-v2 tab-active' : 'mytab mytab-v2'}
                onClick={() => {
                  if (setValue)
                    setValue(0)
                  setActiveTab(index)
                }}
              >
                {tab}
              </button>
            )
          })
        }
      </div>
      {/* <div className="mytab-content-container">{getTabContent()}</div> */}
    </div>
  )
}

export default TabWithBottomBorder